define('modules/form_editor/models/custom_fblogin',['require','exports','module','./base_form_element','modules/editor/models/editorstate'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element"),
      EditorState = require("modules/editor/models/editorstate");

  module.exports = BaseFormElement.extend({
    name: "custom:login:facebook",
    isIntegrable: false,
    onlyFieldAttrs: true,
    defaultValues: {
      appId: "",
      size: "small",
      position: "center",
      idName: "lpg-fb-login"
    },
    initialize: function(){
      module.exports.__super__.initialize.apply(this, arguments);
      this.on("change:appId", this.notifyIdChange);
    },
    notifyIdChange: function(nop, id) {
      EditorState.setFBAppId(id);
    }
  });
});

